import React, { useRef } from 'react';
import { getAllProducts } from '../../../usecases/products-usecase';
import { useState } from 'react';
import { EmptyArray } from '../../../domain/empty/model';
import * as XLSX from 'xlsx';
import { AiOutlineUpload } from "react-icons/ai";
import './style.css';

const ExcelUploadButton = (props) => {
    const { onUpload } = props;
    const fileInputRef = useRef(null);
    const [products, setProducts] = useState([]);

    const handleButtonClick = () => {
        handleOpen();
        fileInputRef.current.click();
    };

    function handleOpen() {
        getAllProducts("", "").then((res) => {
            if (res.length === 0) {
                setProducts(EmptyArray)
            } else {
                setProducts(res.filter(p => p.enable))
            }
        }).catch(() => {
            setProducts(EmptyArray)
        })
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (jsonData.length === 0) {
                if (onUpload) {
                    onUpload([]);
                }
                event.target.value = '';
                return;
            }

            const headers = jsonData[0];
            const rows = jsonData.slice(1);

            const jsonArray = rows.map(row => {
                const obj = {};
                headers.forEach((header, index) => {
                    obj[header] = row[index] !== undefined ? String(row[index]) : '';
                    if (header === 'SKU') {
                        const product = products.find(p => p.sku === String(row[index]));
                        if (product) {
                            obj['relatedItem'] = product;
                        }
                    }
                });
                return obj;
            });

            if (onUpload) {
                onUpload(jsonArray);
            }

            event.target.value = '';
        };
        reader.readAsArrayBuffer(file);
    };

    const renderButton = () => {
        if (props.component) {
            return <props.component onClick={handleButtonClick}>{props.children || "Cargar plantilla"}</props.component>;
        }
        return (
            <button
                onClick={handleButtonClick}
                className="btn-upload-xlsx"
            >
                <AiOutlineUpload /> Cargar Excel
            </button>
        );
    };

    return (
        <>
            <input
                type="file"
                accept=".xlsx, .xls"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
            {renderButton()}
        </>
    );
};

export default ExcelUploadButton;
